import React, {useState} from 'react';
import SignatureDialog from 'components/Editors/SignatureDialog';
import {i18n2} from './../../features/i18n/i18n';
import {useUtilInformation} from 'components/hooks';
import {
  downloadReportGeneric,
  downloadReportPDF,
  downloadMonthlyReport,
  cancelRequest,
  ReportTypes,
} from 'helpers/report';
import {useSelector} from 'react-redux';

const signalError = 'signal is aborted without reason';
const successfulDownload = 'El reporte fue generado.';
const downloadCanceled = 'La descarga del reporte fue cancelada.';

const PopupReport = ({
  open,
  setOpen,
  name,
  url,
  filters,
  pdfOnly = true,
  type = ReportTypes.PDF,
  userFilters = null,
  isMonthly = false,
}) => {
  const token = useSelector((state) => state.authentication.user.token);
  const [snackbar, setSnackbar] = useState({open: false, message: ''});
  const {cwid} = useUtilInformation();

  const downloader = isMonthly
    ? downloadMonthlyReport
    : pdfOnly
      ? downloadReportPDF
      : downloadReportGeneric;
  const preSubmit = (signature, setSubmitting) => {
    const promise = isMonthly
      ? downloader(token, name, url, signature, type, userFilters)
      : downloader(token, filters, name, url, signature, type, userFilters);

    promise.then((response) => {
      if (response === true) {
        setSnackbar({open: true, message: successfulDownload});
        setOpen(false);
      } else {
        if (response?.message === signalError) {
          setSnackbar({open: true, message: downloadCanceled});
        } else {
          setSnackbar({open: true, message: response});
        }
        setSubmitting(false);
      }
    });
  };

  const handleCloseDialog = () => {
    setOpen(false);
    cancelRequest();
  };

  return (
    <>
      <SignatureDialog
        requireReason={true}
        disableEscape={false}
        openDialog={open}
        onCloseDialog={handleCloseDialog}
        dialogTitle={i18n2._('Descargar reporte')}
        user={cwid}
        submit={(values, {setSubmitting}) => preSubmit(values, setSubmitting)}
        snackbarState={snackbar}
        onCloseSnackbar={() => setSnackbar({open: false, message: ''})}
      />
    </>
  );
};

export default PopupReport;
